import type { LucideIcon } from 'lucide-react'

/**
 * Botón de acción flotante (FAB): la acción principal de una pantalla, siempre a mano en
 * el celular. Solo ícono, así que `etiqueta` es su nombre accesible (y el tooltip). El kit
 * no trae uno; el aspecto vive en styles/app.css (`.fab`) con las variables de rol, y solo
 * se muestra bajo 900px, encima de la barra inferior flotante.
 */
export function Fab({ icono: Icono, etiqueta, onClick }: { icono: LucideIcon; etiqueta: string; onClick: () => void }) {
  return (
    <button type="button" className="fab no-print" aria-label={etiqueta} title={etiqueta} onClick={onClick}>
      <Icono className="dcc-i" size={26} aria-hidden />
    </button>
  )
}
